(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["hd-flash-offer"] && !Shopify.designMode) return;
  try {
    function hdFlashBadge() {
    const src = document.querySelector('[data-hd-flash-badge]');
    if (!src || src.__done) return;
    const svg = src.querySelector('.hd-flash-badge');
    if (!svg) return;
    const media =
      document.querySelector('.product-information__media slideshow-container') ||
      document.querySelector('.product-information__media slideshow-slides') ||
      document.querySelector('.product-information__media slideshow-component') ||
      document.querySelector('.product-information__media');
    if (!media || media.querySelector('.hd-flash-badge')) return;
    src.__done = true;
    if (getComputedStyle(media).position === 'static') media.style.position = 'relative';
    media.appendChild(svg);
  }
  document.addEventListener('DOMContentLoaded', hdFlashBadge);
  hdFlashBadge();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hd-payments"] && !Shopify.designMode) return;
  try {
    function hdPayInit() {
    document.querySelectorAll('[data-hd-pay-open]').forEach((btn) => {
      if (btn.__hdPay) return;
      btn.__hdPay = true;
      const dlg = document.getElementById(btn.dataset.hdPayOpen);
      if (!dlg) return;
      btn.addEventListener('click', () => dlg.showModal());
      dlg.querySelectorAll('[data-hd-pay-close]').forEach((c) => c.addEventListener('click', () => dlg.close()));
      const tabs = Array.from(dlg.querySelectorAll('[data-hd-pay-tab]'));
      const panes = Array.from(dlg.querySelectorAll('[data-hd-pay-pane]'));
      tabs.forEach((tab) => {
        tab.addEventListener('click', () => {
          tabs.forEach((t) => t.classList.toggle('is-active', t === tab));
          const key = tab.dataset.hdPayTab;
          panes.forEach((p) => { p.hidden = p.dataset.hdPayPane !== key; });
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', hdPayInit);
  hdPayInit();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hd-pickup"] && !Shopify.designMode) return;
  try {
    (function () {
    var GEO_CACHE_KEY = 'hdGeoBairro';
    var GEO_TTL_MS = 7 * 24 * 60 * 60 * 1000; // 7 dias

    function normalize(s) {
      return (s || '')
        .toString()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '') // remove acentos
        .toLowerCase()
        .replace(/\s+/g, ' ')
        .trim();
    }

    function splitList(raw) {
      return (raw || '')
        .split(/[,\n;]+/)
        .map(function (x) { return x.trim(); })
        .filter(Boolean);
    }

    function readCache() {
      try {
        var raw = window.localStorage.getItem(GEO_CACHE_KEY);
        if (!raw) return null;
        var data = JSON.parse(raw);
        if (!data || !data.ts || (Date.now() - data.ts) > GEO_TTL_MS) return null;
        return data;
      } catch (e) { return null; }
    }

    function writeCache(bairro) {
      try {
        window.localStorage.setItem(GEO_CACHE_KEY, JSON.stringify({ bairro: bairro, ts: Date.now() }));
      } catch (e) {}
    }

    // Aplica o texto "entrega no mesmo dia / para o bairro X" no card-alvo.
    function applyHit(wrap, bairro) {
      var cardId = wrap.getAttribute('data-geo-card') || '2';
      var card = wrap.querySelector('.hd-pickup__card[data-card="' + cardId + '"]');
      if (!card) return;
      var titleEl = card.querySelector('.hd-trust-item__title');
      var subEl = card.querySelector('.hd-trust-item__subtitle');
      var title = wrap.getAttribute('data-geo-title') || 'Entrega no mesmo dia';
      var prefix = wrap.getAttribute('data-geo-prefix') || 'para o bairro';
      if (titleEl) titleEl.textContent = title;
      if (subEl) subEl.textContent = (prefix + ' ' + bairro).replace(/\s+/g, ' ').trim();
      card.classList.add('is-geo-hit');
    }

    // Coleta tokens de nome de lugar da resposta do Nominatim.
    function collectTokens(data) {
      var tokens = [];
      var a = data.address || {};
      ['suburb', 'neighbourhood', 'quarter', 'city_district', 'borough', 'residential'].forEach(function (k) {
        if (a[k]) tokens.push(a[k]);
      });
      if (data.display_name) {
        data.display_name.split(',').forEach(function (seg) { tokens.push(seg); });
      }
      return tokens.map(normalize);
    }

    function cityAllowed(data, allowedNorm) {
      var a = data.address || {};
      var city = normalize(a.city || a.town || a.municipality || a.village || a.county || '');
      if (!city) return false;
      return allowedNorm.indexOf(city) !== -1;
    }

    // Retorna o nome canônico do bairro (com acento) se houver match, senão null.
    function matchBairro(data, wrap) {
      var allowed = splitList(wrap.getAttribute('data-geo-cities')).map(normalize);
      if (allowed.length && !cityAllowed(data, allowed)) return null;
      var tokens = collectTokens(data);
      var hoods = splitList(wrap.getAttribute('data-geo-hoods'));
      for (var i = 0; i < hoods.length; i++) {
        if (tokens.indexOf(normalize(hoods[i])) !== -1) return hoods[i];
      }
      return null;
    }

    function reverseGeocode(lat, lon) {
      var url = 'https://nominatim.openstreetmap.org/reverse?format=jsonv2&zoom=16&addressdetails=1'
        + '&accept-language=pt-BR&lat=' + encodeURIComponent(lat) + '&lon=' + encodeURIComponent(lon);
      var ctrl = new AbortController();
      var timer = setTimeout(function () { ctrl.abort(); }, 8000);
      return fetch(url, { signal: ctrl.signal, headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .finally(function () { clearTimeout(timer); });
    }

    function runDetection(wrap, onResolved) {
      if (wrap.dataset.geoDone === '1') return;
      if (!('geolocation' in navigator)) return;

      // O navegador abre o pop-up de permissão automaticamente ao chamar getCurrentPosition.
      navigator.geolocation.getCurrentPosition(
        function (pos) {
          wrap.dataset.geoDone = '1';
          if (onResolved) onResolved();
          reverseGeocode(pos.coords.latitude, pos.coords.longitude)
            .then(function (data) {
              if (!data) return;
              var bairro = matchBairro(data, wrap);
              if (bairro) {
                applyHit(wrap, bairro);
                writeCache(bairro);
              }
              // Sem match: mantém o card como está (nada prometido fora da área).
            })
            .catch(function () {});
        },
        function (err) {
          // code 1 = PERMISSION_DENIED (definitivo) → para de tentar.
          // timeout / posição indisponível → deixa o próximo gesto tentar de novo.
          if (err && err.code === 1) {
            wrap.dataset.geoDone = '1';
            if (onResolved) onResolved();
          }
        },
        { enableHighAccuracy: false, timeout: 8000, maximumAge: 600000 }
      );
    }

    function initWrap(wrap) {
      if (!wrap || wrap.dataset.geoReady === '1') return;
      if (wrap.getAttribute('data-geo') !== 'true') return;
      wrap.dataset.geoReady = '1';

      // 1) Cache de sessão: já detectamos um bairro válido antes → aplica na hora (sem re-perguntar).
      var cached = readCache();
      if (cached && cached.bairro) {
        // Confirma que o bairro cacheado ainda está na lista configurada.
        var hoods = splitList(wrap.getAttribute('data-geo-hoods')).map(normalize);
        if (hoods.indexOf(normalize(cached.bairro)) !== -1) {
          applyHit(wrap, cached.bairro);
          return;
        }
      }

      // 2) Sem cache: pede a localização no load E no primeiro gesto do usuário.
      // Navegadores suprimem geolocalização automática sem "user gesture"; o gesto
      // (toque/scroll/clique em qualquer lugar) destrava o pop-up — sem botão visível.
      var GEST = ['pointerdown', 'touchstart', 'keydown', 'wheel', 'scroll'];
      function detach() {
        GEST.forEach(function (ev) { window.removeEventListener(ev, onGesture, true); });
      }
      function onGesture() {
        runDetection(wrap, detach);
      }
      runDetection(wrap, detach); // tentativa no load (onde o navegador permitir)
      GEST.forEach(function (ev) {
        window.addEventListener(ev, onGesture, { capture: true, passive: true });
      });
    }

    function initAll(root) {
      var scope = root && root.querySelectorAll ? root : document;
      scope.querySelectorAll('[data-hd-pickup][data-geo="true"]').forEach(initWrap);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function () { initAll(document); });
    } else {
      initAll(document);
    }
    // Re-inicializa no editor de tema (recarrega de seção/bloco).
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target || document); });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hd-tabs"] && !Shopify.designMode) return;
  try {
    function hdTabsInit() {
    document.querySelectorAll('[data-hd-tabs]').forEach((root) => {
      if (root.__hdTabs) return;
      root.__hdTabs = true;
      const tabs = Array.from(root.querySelectorAll('[data-hd-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-hd-panel]'));
      const activate = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
        });
        panels.forEach((p) => {
          p.hidden = p.id !== tab.getAttribute('aria-controls');
        });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => activate(tab));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          e.preventDefault();
          const dir = e.key === 'ArrowRight' ? 1 : -1;
          const next = tabs[(i + dir + tabs.length) % tabs.length];
          next.focus();
          activate(next);
        });
      });
    });
  }
  document.addEventListener('DOMContentLoaded', hdTabsInit);
  hdTabsInit();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["hd-videos"] && !Shopify.designMode) return;
  try {
    (function () {
    function initVideos() {
      const modal = document.querySelector('[data-hd-video-modal]');
      const videoEl = modal && modal.querySelector('[data-hd-video-el]');
      if (!modal || !videoEl) return;

      document.querySelectorAll('[data-hd-video]').forEach((item) => {
        if (item.__hdV) return;
        item.__hdV = true;
        item.addEventListener('click', () => {
          videoEl.src = item.dataset.hdVideo;
          videoEl.muted = false;
          videoEl.play().catch(() => {});
          if (typeof modal.showModal === 'function') modal.showModal();
        });
      });

      if (!modal.__hdInit) {
        modal.__hdInit = true;
        modal.querySelector('[data-hd-video-close]')?.addEventListener('click', () => modal.close());
        modal.querySelector('[data-hd-video-mute]')?.addEventListener('click', () => {
          videoEl.muted = !videoEl.muted;
        });
        modal.addEventListener('close', () => {
          videoEl.pause();
          videoEl.removeAttribute('src');
          videoEl.load();
        });
      }
    }
    document.addEventListener('DOMContentLoaded', initVideos);
    initVideos();
  })();
  } catch(e) { console.error(e); }
})();

})();
